var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0001 2.66667C8.64008 2.66667 2.66675 8.64001 2.66675 16C2.66675 23.36 8.64008 29.3333 16.0001 29.3333C23.3601 29.3333 29.3334 23.36 29.3334 16C29.3334 8.64001 23.3601 2.66667 16.0001 2.66667ZM16.0001 6.66667C18.2134 6.66667 20.0001 8.45334 20.0001 10.6667C20.0001 12.88 18.2134 14.6667 16.0001 14.6667C13.7867 14.6667 12.0001 12.88 12.0001 10.6667C12.0001 8.45334 13.7867 6.66667 16.0001 6.66667ZM16.0001 25.6C12.6667 25.6 9.72008 23.8933 8.00008 21.3067C8.04008 18.6533 13.3334 17.2 16.0001 17.2C18.6534 17.2 23.9601 18.6533 24.0001 21.3067C22.2801 23.8933 19.3334 25.6 16.0001 25.6Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserProfile);
export default __webpack_public_path__ + "static/media/user-profile.31bd1efcd6b17e4f283f2eca86d1f001.svg";
export { ForwardRef as ReactComponent };